module.exports = __webpack_public_path__ + "c72f8cfcd86e6054d2ed1c9e6ac45dbc.pdf";